/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Loader, useModal } from '@jutro/components';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext,useState, useEffect } from 'react';
import { AddressStandardizationService } from 'twia-capability-addressstandardization';
import { GatewayEndorsementService as LoadSaveService} from 'twia-capability-gateway-policychange';
import { PolicyDiffComponent } from "gw-capability-policyjob-react/index.js";
import addressControl from '../../util/addressControl';
import metadata from './CoverageSummaryPage.metadata.json5';
import messages from './CoverageSummaryPage.messages';
import styles from './CoverageSummaryPage.module.scss';
import Offerings from 'tfpa-capability-quoteandbind-residential-react/components/Quote/Offerings/Offerings.jsx';
import { TWIAAddressComponent, TWIAEmailComponent } from 'twia-capability-address-component';
import PayorComponent from '../../components/TFPAAddressComponent/PayorComponent/PayorComponent.jsx';
import TFPACustomQuoteService from '../../../../capabilities/tfpa-capability-quoteandbind-residential/services/TFPACustomQuoteService.js';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil.js';
import { wizardMessages } from 'tfpa-portals-wizard-components-ui';

function TFPACoverageSummaryPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, setIsLoading] = useState(false);
    const translator = useContext(TranslatorContext);
    const { id, wizardData: submissionVM, updateWizardData } = props;
    const [accountHolderVM, setAccountHolderVM] = useState(submissionVM.baseData.accountHolder);
    const [addressVM, setAddressVM] = useState(submissionVM.baseData.policyAddress);
    const isPhoneNumberValid = (phone) => /^[2-9]\(?([0-9]{2})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(phone); //DE16358
    const [showErrors, setShowErrors] = useState(false);
    const { showAlert, showConfirm } = useModal();
    const [phoneValidationMessage, setPhoneValidationMessage] = useState([]);
    const { authHeader } = useAuthentication();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const country = _.get(accountHolderVM, 'primaryAddress.country.value.code');
    const selectedUWCompany = _.get(submissionVM, 'baseData.associationName_TWIA.value.code');
    const { isComponentValid, initialValidation, onValidate } = useValidation('TFPACoverageSummaryPage');
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [ pcConstants, setPCConstants ] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false);
    const xPortal = 'PE';
    const jobID = _.get(submissionVM, 'jobID.value');
    
    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const onNext = useCallback(async() => {
        updateSubmissionVM();
        _.set(submissionVM,'bindData_TFPA.portalPayorType_Ext.value', "primarynameinsured");
        if (!_.isEmpty(invalidComponent) || !(submissionVM.bindData_TFPA.contactPhone.aspects.valid)) {
            setPhoneValidationMessage(submissionVM.bindData_TFPA.contactPhone.aspects.validationMessages)
            setShowErrors(true);
            return false
        }
        setShowErrors(false);
        try {
            //US26840
            // const result = await TFPACustomQuoteService.updateQuoteAndRetrievePaymentPlans(
            //     submissionVM.value,
            //     submissionVM.sessionUUID.value,
            //     authHeader
            // );
            submissionVM.validationParams_TWIA.value = {
                validationLevel: 'default',
                validationWizardStep: 'MailingInfo',
                skipAllValidation: false
            };
            submissionVM.value = await LoadSaveService.saveQuotedEndorsement_TWIA(
                submissionVM.value,
                authHeader
            )
            // _.set(submissionVM,'bindData_TFPA.paymentPlans.value',result);
            updateWizardData(submissionVM);
            setIsAddressEdited(false);
            return submissionVM;
        } catch (error) {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, false);
            return false;
        }
    }, [updateSubmissionVM, invalidComponent, submissionVM, authHeader, updateWizardData, 
        showAlert]);

    const getPCConstants = useCallback(async () => {
        const constants = await AddressStandardizationService.getPCPortalConstants(authHeader);
        if (constants.addressStandardizationDisabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setPCConstants(constants);
    }, []);
    
    const setDisablity = useCallback((value) => {
        if (isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [updateDisablity]);
    
    useEffect(() => {
        const offeredQuotes = _.get(
            submissionVM.value,
            'quoteData.offeredQuotes[0].publicID'
        );
        _.set(submissionVM, 'bindData_TFPA.chosenQuote', offeredQuotes);
        updateWizardData(submissionVM)
        setAccountHolderVM(submissionVM.baseData.accountHolder);
        setAddressVM(submissionVM.baseData.accountHolder.primaryAddress);
        getPCConstants();
    }, []);

    const validatePhoneNumber = useCallback( //DE16358
        (value, path) => {

            if (value.match(/[a-z A-Z]/g)) {
                return false;
            }

            if (value.length === 3 || value.length === 7) {
                value += "-"
            }

            setPhoneValidationMessage([]);

            if (!value) {

                setPhoneValidationMessage([]);
            } else if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {

                setPhoneValidationMessage([translator(messages.PhoneValidationMessage)])
            }

            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
            setPhoneValidationMessage(submissionVM.bindData_TFPA.contactPhone.aspects.validationMessages)
        },
        [submissionVM, translator, updateWizardData]);

    const onPrevious = useCallback(() => {
        if (invalidComponent.length > 0) {
            return showConfirm({
                title: wizardMessages.TWIAWizardModalTitle,
                message: wizardMessages.TWIAWizardModalMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
                cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            }).then((results) => {
                if (results === 'cancel' || results === 'close') {
                    setShowErrors(true);
                    return false;
                }                
                return true;
            }, _.noop)
        }
    }, [invalidComponent]);
    
    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    },[]);

    const updatePolicyAddressVM = useCallback((value) => {
        _.set(submissionVM, 'baseData.accountHolder.primaryAddress', value);
        _.set(submissionVM, 'baseData.policyAddress.value', value);
        setDisablity(value);
        if(value.isValidated_Ext === true || value.isOverridden_Ext === true) {
            setIsAddressEdited(false);
        }
        updateWizardData(submissionVM);
    }, [setDisablity, submissionVM, updateWizardData]);

    
    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    });

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        emailAddressComponent: {
            accountHolderVM, updateSubmissionVM, authHeader, showErrors, findInvalidComponent, onValidate,
            companyType: selectedUWCompany
        },
        mailingAddressComponent: {
            addressVM, updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate, 
            companyType: selectedUWCompany,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            xPortal
        },
        // payorComponent: {  //US26840
        //     submissionVM, updateSubmissionVM, country, showErrors, findInvalidComponent, onValidate, 
        //     isStandardizationDisabled, 
        //     isButtonDisabled
        // },
        phoneNumber: {
            validationMessages: _.isEmpty(phoneValidationMessage) && 
            _.get(submissionVM, 'bindData_TFPA.contactPhone.value') === undefined &&
            _.get(submissionVM, 'bindData_TFPA.contactPhone.aspects.required')
            ? [translator(messages.required)] : phoneValidationMessage
        },
        offeringDetails: {  //US26839
            visible: !_.isUndefined(submissionVM),
            readOnly : true,
            submissionVM,
            discSurgValue:_.get(submissionVM,'lobData.homeowners_tfpa.coverages.discountsSurchargesAndFees_Ext.value'),
            insuredValue: _.get(submissionVM,'lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value'), // DE16446
            ho205CovDesc: (_.get(submissionVM,'lobData.homeowners_tfpa.coverages.homeOfficeLiabDesc_Ext.value')),
            ho205CovValue: (_.get(submissionVM,'lobData.homeowners_tfpa.coverages.medPayOthers_Ext.value')), // DE16447
            isTFPACoverageSummary:true
        },
        totalPremium: {
            value: {
                amount: _.get(submissionVM, 'quoteData.offeredQuotes.value[0].premium.total.amount'),
                currency: "USD"
            }
        },
        propertyAddress:{ // DE17801
            value:_.get(submissionVM,'lobData.homeowners_tfpa.coverables_Ext.yourHome.primaryAddress.displayName.value')?.split(":")[1]
        },
        PolicyDiffComponent:{
            value: jobID,
        },
    };

    const resolvers = {
        resolveComponentMap: {
			offeringComponent: Offerings,
            emailComponent: TWIAEmailComponent,
            addressComponent: TWIAAddressComponent,
            PolicyDiffComponent: PolicyDiffComponent
            // payorComponent: PayorComponent,
            // OnValidatePhoneNumber: validatePhoneNumber,
			},
            resolveCallbackMap: {
                OnValidatePhoneNumber: validatePhoneNumber
            },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
            disableNext={isButtonDisabled || isAddressEdited}
            onPrevious={onPrevious}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    showErrors={showErrors}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    onValidationChange={onValidate}
                    componentMap={resolvers.resolveComponentMap}
                    callbackMap={resolvers.resolveCallbackMap}
                />
            </Loader>
        </WizardPage>
    );
}

TFPACoverageSummaryPage.propTypes = wizardProps;
export default TFPACoverageSummaryPage;
